import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormsModule, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
// Angular Common Standalone Pieces
import { CommonModule, NgClass } from '@angular/common';
import { LowerCasePipe } from '@angular/common';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import moment from 'moment';
import { Api } from 'src/app/services/api';
import { MatDatepickerModule, MatDatepickerToggle } from '@angular/material/datepicker';
import { MultipleDatesComponent } from 'ngx-multiple-dates';
import { MatNativeDateModule } from '@angular/material/core';
 // module import
import { MatSelectModule } from '@angular/material/select';
// radio
import {MatRadioModule} from '@angular/material/radio';
// Textarea
import { TextFieldModule } from '@angular/cdk/text-field';
// sweetalert
import Swal from 'sweetalert2';
// import 'moment/locale/es';
export interface TimeOffData {
  available: number;
  granted: number;
  used: number;
  vacacion_advance:number;
  history: Array<{
    date: string;
    days: number;
    status: string;
  }>;
}
export interface TimeOffItem {
  date: string;
  days: number;
  status: string;
  icon?: string;
  css?: string;
}
export interface Approvers{
names:string,
userids:any,
}

 interface CalendarLoadOLD {
  [date: string]: number;
}
interface CalendarLoad {
  [date: string]: { aprobado: number; revision: number };
}
@Component({
  selector: 'app-time-off',
  standalone: true,
  templateUrl: './time-off.html',
  styleUrls: ['./time-off.scss'],
  imports: [
    ReactiveFormsModule,
    MatIcon,FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,MatRadioModule,
    CommonModule,
    MatSelectModule,TextFieldModule,
    MultipleDatesComponent,
MatDatepickerModule,MatNativeDateModule,
MatDatepickerToggle
  ]
})
export class TimeOffComponent implements OnInit, AfterViewInit{
selectedSucursal:any;
calendarMap: Record<string, CalendarLoad> = {};
granted:any = 0;
used:any = 0;
available:any = 0;
vacacion_advance:any = 0;
form: FormGroup;
myid = localStorage.getItem('userid');
approvers: Approvers = { names: '', userids: '' };
previousDates: Date[] = [];
mihistorial: any[] = [];
subdateMap = new Map<number, Date>(); // idBD -> Date
fechas: any;
sucursaleslist:any;
tenure_months = 0;
// TipoTimeOff: string[] = ['Illness', 'Family Emergency', 'Bereavement', 'Official Duty', 'Special Permission', 'Vacations','Other'];
TipoTimeOff: string[] = ['Vacations','Other'];
ingreso:any;
tipodetimeoff:any;
history:TimeOffItem[];
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: TimeOffData,
    private dialogRef: MatDialogRef<TimeOffComponent>,
    private apiservice: Api
  ) {
    this.form = this.fb.group({
      tipodetimeoff: ['', Validators.required],
      days: ['', [Validators.required, Validators.min(1)]],
      other_timeoff:[''],
      reqcomments:[''],
     dates: [[], Validators.required],
     sucursal:['', Validators.required]
    });
    this.form.get('dates')?.valueChanges.subscribe(dates => {
    console.log("🔥 fechas cambiaron:", dates);

    this.detectAddedRemoved(dates);
      // 🔁 calendar re-renders after selection
  setTimeout(() => this.applyYellowDays(), 0);
  });
      this.form.get('tipodetimeoff').valueChanges.subscribe(tipodetimeoffValue => {
  const daysControl = this.form.get('days');
// console.log('tipodetimeoffValue ',tipodetimeoffValue)
  // Define the base validators
  const baseValidators = [Validators.required, Validators.min(1)];

  if (tipodetimeoffValue === 'Vacations') {
    // If it's 'Vacations', add the max validator
    // agreggue vacacion_advance para que si le dasn advance se pueda enviar la solucitd
    daysControl.setValidators([
      ...baseValidators,
      Validators.max(this.available + this.vacacion_advance)
    ]);
  } else {
    // Otherwise, only keep the base validators
    daysControl.setValidators(baseValidators);
  }

  // Recalculate the validation status for the days control
  daysControl.updateValueAndValidity();
});
  }

ngOnInit(){
    this.getmydata();
}
ngAfterViewInit():void {
    this.getMyvacations();
}
GetAllSucursalVacations(sucursal:any){
 this.apiservice.rawquery('timeoff_history', btoa(`SELECT toff.id, toff.userid, toff.dateOff, toff.requeststatus, toff.sucursal FROM timeoff toff WHERE toff.requeststatus <> 'Rechazado' AND sucursal = ${sucursal}`)).subscribe({
    next:(misvaca)=>{
      console.log('Sucursal vacaciones ',misvaca);
      this.buildCalendarMap(misvaca, sucursal);
    },
    error:(err)=>{
      this.apiservice.showMessageWithAnimation(`Error leyendo el historial de vacaciones ${err.error.error}`,'error');
    }
  });
}

getMyvacations(){
  this.apiservice.getForTable('timeoff_history', `userid=${this.myid}`).subscribe({
    next:(misvaca)=>{
      console.log('mis vacaciones ',misvaca);
      this.history = misvaca.length > 0 ? this.transformTimeOff(misvaca) : [];
    },
    error:(err)=>{
      this.apiservice.showMessageWithAnimation(`Error leyendo tu historial de vacaciones ${err.error.error}`,'error');
    }
  });
}

saveRequest(payload){
  this.apiservice.addItem(payload,'timeoff', false).subscribe({
    next:(savereq)=>{
      console.log(savereq);

    },
    error:(err)=>{
      console.log('error guardado request', err.error.error);
      this.apiservice.showMessageWithAnimation(`Error enviando la solicitud ${err.error.error}`,'error');
    }
  })
}
sendmessage(payload){
  this.apiservice.addItem(payload,'messages', false).subscribe({
    next:(savereq)=>{
      console.log(savereq);
    },
    error:(err)=>{
      console.log('error enviando mensaje', err.error.error);
      this.apiservice.showMessageWithAnimation(`Error enviando mesanje avisandio la solicitud ${err.error.error}`,'error');
    }
  })
}
  submitRequest() {
    // let sucursale= localStorage.getItem('suscursal');

    if (this.form.invalid) return;
    let sonvacaciones =false;
    if(this.tipodetimeoff == 'Vacations'){
      sonvacaciones = true;
    }
    let commonid = moment().format('YYMMDD');
    let hex = Math.floor(Math.random() * 0x10000).toString(16).padStart(4, '0').toUpperCase();
      // console.log(this.previousDates);
      let dias =  this.previousDates.length > 1 ? 'días' : 'día';
      let msg = `El empleado ${localStorage.getItem('nombre')} ${localStorage.getItem('apellido')}, solicito ${dias} de vacaciones, favor de checar solicitud.`;
      let fech = this.previousDates.map(f => moment(f).local().format("DD/MMM/YY")).join(', ');
      let comment = `${this.previousDates.length} ${dias} solicitados: ${fech}`;
      let tipo = this.form.get('tipodetimeoff').value || '';
      let other_ = this.form.get('other_timeoff').value || '';
      let reqcomments_ = this.form.get('reqcomments').value || '';
      this.previousDates.forEach( v=> {
      let singlePayload = {
    userid: this.myid,
    requeststatus: 'En revisión',
    sucursal: this.form.get('sucursal').value,
    dateOff: moment(v).local().format("YYYY-MM-DD"),
    linkid:`${commonid}${this.myid}${hex}`,
    approvers:this.approvers.userids,
    approvedbynames:this.approvers.names,
    tipodetimeoff: tipo,
    paid: sonvacaciones ? 1 : 0,
    other_timeoff: other_,
    reqcomments: reqcomments_,
    comments:comment,
    advanced: this.vacacion_advance > 0 ? 1 : 0,

  };
        this.saveRequest(singlePayload);
        console.log(singlePayload);
      });
         if(this.vacacion_advance > 0){
        let q = `UPDATE financial_profile SET vacacion_advance = (IFNULL(vacacion_advance,0)+${this.vacacion_advance}) WHERE employee = ${this.myid}`;
      this.apiservice.rawquery('advace ', btoa(q)).subscribe({
        next:(adv)=>{
          console.log('advance ', adv);
        }
      })
      }
      // send messages
     let mensajessend = this.approvers.userids.split(',');
     mensajessend.forEach(userid => {
        console.log('msg ', userid, ' msg ', msg);
           this.sendmessage({tipo:'Request',to_user:userid,message:msg,new:1, sucursal:this.form.get('sucursal').value});
      });
   this.apiservice.showMessageWithAnimation('Solicitud enviada para aprobación', 'info');
   setTimeout(() => {
        this.dialogRef.close({ requestedDays: this.form.value.days });
   }, 1000);
  }

  close() {
    this.dialogRef.close();
  }
getmydata(){

  this.apiservice.getForTable('sysusersview_two', `id = ${this.myid}`).subscribe({
    next:(miid)=>{
      this.reglavaciones(miid[0]);
      console.log('lkois daots ', miid);
      this.Findsucursal(this.myid);
    },
    error:(err)=>{
      console.log(`error leyendo datos de perfil ${err.error.error}`);
    }
  })
}
    reglavaciones(datos){
  if (datos) {
    this.granted = datos?.vacacionesCorrespondientes;
    this.used = Number(datos?.vacacionesUsadas);
    this.ingreso = datos?.ingreso;
                console.log("vacacionesUsadas:", datos);
this.vacacion_advance = datos?.vaca_advance_dadas;
    const ingreso = datos?.ingreso;
    const months = moment().diff(moment(ingreso), 'months');
    console.log("Months:", months);
          this.tenure_months = months;
this.TipoTimeOff = months >= 9 ? ['Vacations', 'Other'] : ['Other'];
    this.apiservice.getForTable('rule_vac').subscribe({
      next: (vac: any[]) => {
        if (vac.length > 0) {
          // Convert anios → meses
          vac = vac.map(v => ({ ...v, meses: Number(v.anios) * 12 }));
          // Sort rules by months
          vac.sort((a, b) => a.meses - b.meses);
          // Get the first rule (1-year rule)
          const firstRule = vac[0];
          const diasRule = Number(firstRule.dias);
          let diasFinal = 0;
          // CASE 1: Less than the first rule (e.g., 2 months < 12)
          if (months < firstRule.meses) {
            diasFinal = Math.round((months / firstRule.meses) * diasRule);
            console.log("Prorated vacation days:", diasFinal);
          }
          else {
            // CASE 2: Normal calculation – find highest rule that fits
            const matchedRule = [...vac].reverse().find(v => months >= v.meses) || firstRule;
            diasFinal = Number(matchedRule.dias);
            console.log("Vacation days according to rule:", diasFinal);
          }
          // Output
          console.log("Final vacation days:", diasFinal);
          this.form.get('diasVacaciones')?.setValue(diasFinal);
            console.log('usadas ', this.used, diasFinal)
          this.available = (Number(diasFinal)-Number( this.used));


        }
      },
      error: (err) => {
        this.apiservice.showMessageWithAnimation(`Error leyendo las reglas de vacaciones: ${err.error}`, 'error');
      }
    });
  }
    }

onDatesChange() {
  const dates: Date[] = this.form.get('dates')?.value || [];
  console.log("🔥 CURRENT DATES:", dates);

  const removed = this.previousDates.filter(
    p => !dates.some(c => c.getTime() === p.getTime())
  );
  const added = dates.filter(
    c => !this.previousDates.some(p => p.getTime() === c.getTime())
  );

  if (added.length){

console.log("➕ Added:s", added);


  }
  if (removed.length) console.log("❌ Removed:", removed);

  this.previousDates = [...dates];
  console.log('previousDates ',  this.previousDates)
}
detectAddedRemoved(dates: Date[]) {

  // Detect removed
  const removed = this.previousDates.filter(
    prev => !dates.some(curr => curr.getTime() === prev.getTime())
  );
  if (removed.length){
console.log("❌ Removed:", removed);
    if(this.vacacion_advance > 0)this.vacacion_advance--;
  }

  // Detect added
  const added = dates.filter(
    curr => !this.previousDates.some(prev => prev.getTime() === curr.getTime())
  );
if (added.length && (this.granted - this.used) == 0){

  console.log("➕ Added:", added);

  added.forEach((d, i) => {

    const requestedDate = moment(d);

    // anniversary for requested year
    const anniversaryThisYear =
      moment(this.ingreso).year(requestedDate.year());

    const hasRenewedVacations =
      requestedDate.isSameOrAfter(anniversaryThisYear, 'day');

    console.log(hasRenewedVacations);

    if (hasRenewedVacations) {
      this.vacacion_advance++;
      let daysControl = this.form.get('days');
      let baseValidators = [Validators.required, Validators.min(1)];
 daysControl.setValidators([
      ...baseValidators,
      Validators.max(this.available + this.vacacion_advance)
    ]);

    }

  });
}
console.log('dates ', dates);
this.form.get('days').setValue(dates?.length);
this.form.get('days')?.markAsTouched();
this.form.get('days')?.updateValueAndValidity();  // Update
  this.previousDates = [...dates];
}
Findsucursal(filtro){
  console.log('findsucursal ', filtro);
        this.apiservice.getForTable('sucursales_view',`FIND_IN_SET(sucursales_view.id,(SELECT sucursal FROM sysusers WHERE id = ${filtro}))`).subscribe({
      next: (data) => {
        console.log('suc ', data)
        this.sucursaleslist = data.filter(v => v.id != "1");
      },
      error: (error) => {
        this.apiservice.showMessageWithAnimation('Error al cargar las sucursales', 'error');
      console.log(false);
      },
      complete: () => {
      }

  });
}
onSucursalChange(event: any) {
  const selectedId = event.value;

  const selectedSucursal = this.sucursaleslist.find(
    x => x.id === selectedId
  );
  console.log("Selected ID:", selectedId);
  console.log("Selected Name:", selectedSucursal?.nombre);
  this.apiservice.getForTable('vacations_apporvers', ` permission_name LIKE '%Vacaciones%' AND permission_name LIKE '%${selectedSucursal?.nombre}%';`).subscribe({
    next:(approvers)=>{
      console.log('apporbvers ', approvers);
      this.approvers.names = approvers.map(x => x.approver).join(", ");
  this.approvers.userids = approvers.map(x => x.userid).join(",");
        // approverIds = data.map(x => x.apporvar_id).join(",");
        // 🔥 clear previous selections
  this.form.get('dates')?.setValue([]);
  this.previousDates = [];
        this.GetAllSucursalVacations(selectedId);
        this.selectedSucursal = selectedId;
    },
    error:(err)=>{
      console.log('error oobteniendo apporvers', err.error.error);
      this.apiservice.showMessageWithAnimation('Al parecer esta sucursal no tiene aún configurado quien apruebe la solicitud','error');
    }
  })
}

STATUS_MAP: Record<string, { icon: string; css: string }> = {
  'Aprobado':   { icon: 'check_circle',    css: 'ok' },
  'En revisión': { icon: 'hourglass_empty', css: 'review' },
  'Rechazado':  { icon: 'cancel',          css: 'reject' }
};

transformTimeOff(data: TimeOffItem[]): TimeOffItem[] {
  return data.map(item => {
    const map = this.STATUS_MAP[item.status] || { icon: 'help', css: 'unknown' };
    return {
      ...item,
      icon: map.icon,
      css: map.css
    };
  });
}
radioChange(tipoTO){
  this.tipodetimeoff = tipoTO.value;
  let formtimeoff = this.form.get('tipodetimeoff').value;
  console.log('tipo de timeoff ', this.tipodetimeoff, formtimeoff);
// other_timeoff

}
timeoffdetails(datos){
  console.log(datos);
  let o = datos.other_timeoff ? `<p><strong>Tipo other:</strong> ${datos.other_timeoff}</p>` : '';
  let razonrch = datos.rechazado_cmnt? `<p><strong>Razón Rechazo:</strong> ${datos.rechazado_cmnt}</p>` : '';
  let sonadvanced = datos.advanced == "1" ? `<p><strong>Son vacaciones adelantadas.</strong></p>` : '';
  let m = `<div style="border:1px solid #ddd; padding:16px; border-radius:8px; font-family:Arial, sans-serif; max-width:100%;">
  <h3 style="margin-top:0; color:#444;">Detalle de Solicitud</h3>
  <p><strong>Fecha de solicitud:</strong> ${datos.date}</p>
  <p><strong>Tipo de solicitud:</strong> ${datos.tipodetimeoff}</p>
  ${o}
  <p><strong>Estado:</strong> ${datos.status}</p>
  ${razonrch}
  <p><strong>Comentarios:</strong>${datos.comments}</p>
   ${sonadvanced}
</div>`;
Swal.fire({
  // title: "loading...",
  title: "Time Off",
  html: m,
});
}


buildCalendarMapOLD(rows: any[], sucursal: string) {
  this.calendarMap[sucursal] = {};

  // rows.forEach(r => {
  //   const date = r.dateOff;
  //   this.calendarMap[sucursal][date] =
      // (this.calendarMap[sucursal][date] || 0) + 1;
  // });
}
buildCalendarMap(rows: any[], sucursal: string) {
  this.calendarMap[sucursal] = {};

  rows.forEach(r => {
    const date = r.dateOff;
    if (!this.calendarMap[sucursal][date]) {
      this.calendarMap[sucursal][date] = { aprobado: 0, revision: 0 };
    }
    if (r.requeststatus === 'Aprobado') {
      this.calendarMap[sucursal][date].aprobado++;
    } else if (r.requeststatus === 'En revisión') {
      this.calendarMap[sucursal][date].revision++;
    }
  });
}
applyYellowDaysOLD() {
  if (!this.selectedSucursal) return;
  const calendar = document.querySelector('.mat-calendar');
  if (!calendar) return;

  const cells = calendar.querySelectorAll(
    '.mat-calendar-body-cell:not(.mat-calendar-body-disabled)'
  );

  cells.forEach((cell: Element) => {
    const aria = cell.getAttribute('aria-label');
    if (!aria) return;

    const m = moment(aria, 'D [de] MMMM [de] YYYY', true);
    if (!m.isValid()) return;

    const key = m.format('YYYY-MM-DD');
    const counts = this.calendarMap[this.selectedSucursal]?.[key];

    cell.classList.remove('day-yellow', 'day-orange');

    const aprobado = counts?.aprobado || 0;
    const revision = counts?.revision || 0;

    if (aprobado >= 1) {
      cell.classList.add('day-yellow');   // confirmed booking
    } else if (revision >= 1) {
      cell.classList.add('day-orange');   // pending, caution
    }
  });
}
applyYellowDays() {
  if (!this.selectedSucursal) return;
  const calendar = document.querySelector('.mat-calendar');
  if (!calendar) return;

  const cells = calendar.querySelectorAll(
    '.mat-calendar-body-cell:not(.mat-calendar-body-disabled)'
  );

  cells.forEach((cell: Element) => {
    const aria = cell.getAttribute('aria-label');
    if (!aria) return;

    // Try Spanish first, fallback to English
    let m = moment(aria, 'D [de] MMMM [de] YYYY', true);
    if (!m.isValid()) {
      m = moment(aria, 'MMMM D, YYYY', true); // English fallback
    }
    if (!m.isValid()) {
      console.warn('Could not parse aria-label:', aria); // 👈 add this to debug
      return;
    }

    const key = m.format('YYYY-MM-DD');
    const counts = this.calendarMap[this.selectedSucursal]?.[key];

    cell.classList.remove('day-yellow', 'day-yellow');

    const aprobado = counts?.aprobado || 0;
    const revision = counts?.revision || 0;

   // console.log(key, { aprobado, revision }); // 👈 check what's being found

    if (aprobado >= 1) {
      cell.classList.add('day-yellow');
    }
    if (revision >= 1) {
      cell.classList.add('day-yellow'); // use if instead of else if so both can show
    }
  });
}
public myFilterOLD = (d: Date | null): boolean => {
  if (!d || !this.selectedSucursal) return true;

  const key = this.formatDate(d);
  const count = this.calendarMap[this.selectedSucursal]?.[key] || 0;

  // return count < 2; // 🔴 block at capacity
};
public myFilter = (d: Date | null): boolean => {
  if (!d || !this.selectedSucursal) return true;
  const key = this.formatDate(d);
  const counts = this.calendarMap[this.selectedSucursal]?.[key];
  const total = (counts?.aprobado || 0) + (counts?.revision || 0);
  return total < 2;
};
formatDate(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}


onCalendarOpened() {
  console.log('Calendar opened');
  setTimeout(() => {
    this.applyYellowDays();

    const next = document.querySelector('.mat-calendar-next-button');
    const prev = document.querySelector('.mat-calendar-previous-button');

    next?.addEventListener('click', () =>
      setTimeout(() => this.applyYellowDays(), 0)
    );

    prev?.addEventListener('click', () =>
      setTimeout(() => this.applyYellowDays(), 0)
    );
  }, 0);
}

applyYellowDaysOld() {
  console.log('Applying yellow days');
  if (!this.selectedSucursal) return;
  console.log('Applying yellow days 1');

  const calendar = document.querySelector('.mat-calendar');
  if (!calendar) return;
  console.log('Applying yellow days 2');

  const cells = calendar.querySelectorAll(
    '.mat-calendar-body-cell:not(.mat-calendar-body-disabled)'
  );
  console.log('Applying yellow days 3');

  cells.forEach((cell: Element) => {
    // const aria = cell.getAttribute('aria-label');
    const matDate = cell.getAttribute('data-mat-date');

      console.log('Applying yellow days aria', matDate);
if (!matDate) return;

const date = new Date(matDate); // ✅ always valid
          console.log('Applying yellow days date', date);

    if (isNaN(date.getTime())) return;
          console.log('Applying yellow days nan', date);

    const key = this.formatDate(date);
    const count = this.calendarMap[this.selectedSucursal]?.[key];
console.log('key ', key, ' count ', count);
    // Clean previous state
    cell.classList.remove('day-yellow');

    // 🟡 Apply yellow when exactly 1 person already booked
    // if (count === 1) {
    //   cell.classList.add('day-yellow');
    // }
  });
}
applyYellowDaysOLDLAST() {
  if (!this.selectedSucursal) return;

  const calendar = document.querySelector('.mat-calendar');
  if (!calendar) return;

  const cells = calendar.querySelectorAll(
    '.mat-calendar-body-cell:not(.mat-calendar-body-disabled)'
  );

  cells.forEach((cell: Element) => {
    const aria = cell.getAttribute('aria-label');
    if (!aria) return;

    // ✅ Parse localized date safely (Spanish)
    const m = moment(aria, 'D [de] MMMM [de] YYYY', true);
    if (!m.isValid()) return;

    const key = m.format('YYYY-MM-DD');
    const count = this.calendarMap[this.selectedSucursal]?.[key];

    // Clean previous state
    cell.classList.remove('day-yellow');

    // 🟡 Exactly 1 person booked
    // if (count === 1) {
    //   cell.classList.add('day-yellow');
    // }
  });
}

}
